import { render, staticRenderFns } from "./OtherCostListFunc.vue?vue&type=template&id=3dadae50&scoped=true&"
import script from "./OtherCostListFunc.vue?vue&type=script&lang=js&"
export * from "./OtherCostListFunc.vue?vue&type=script&lang=js&"
import style0 from "./OtherCostListFunc.vue?vue&type=style&index=0&id=3dadae50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dadae50",
  null
  
)

export default component.exports